import { Api } from 'api/cabmun-api-public';

export interface TotalStatistics extends Api.GetTotals200Response {}
export interface ParticipantsSampleForMunicipality extends Api.TestParticipantsForMunicipality.ParticipantsDatum {}
export interface ParticipantsSampleForRegion extends Api.TestParticipantsForRegion.ParticipantsDatum {}
export interface ParticipantsBase extends Api.TestParticipantsBase {}
export interface ParticipantsForRegion extends Api.TestParticipantsForRegion {}
export interface ParticipantsForMunicipality extends Api.TestParticipantsForMunicipality {}

export interface ProgressesParallelsForRegion extends Api.TestProgressesForRegion.ParallelsCompletionPercent {}
export interface ProgressesAvgForRegion extends Api.TestProgressesForRegion.AvgCompletionPercent {}
export interface ProgressesParallelsForMunicipality
  extends Api.TestProgressesForMunicipality.ParallelsCompletionPercent {}
export interface ProgressesAvgForMunicipality extends Api.TestProgressesForMunicipality.AvgCompletionPercent {}
export interface ProgressesForMunicipality extends Api.TestProgressesForMunicipality {}
export interface ProgressesForRegion extends Api.TestProgressesForRegion {}
export interface TestProgressesTotal extends Api.TestProgressesTotal {}
export interface TestProgressesAvg extends Api.TestProgressesAvg {}
export interface TestProgressesParallels extends Api.TestProgressesParallels {}
export interface Test extends Api.GetTestsList200Response {}
export type Participants = ParticipantsForRegion | ParticipantsForMunicipality;
export enum Subject {
  Math = 'Математика',
  Russian = 'Русский Язык',
  // English = 'Английский Язык',
}

export enum ParticipantType {
  Teacher,
  Student,
}

export enum TestRound {
  First = 'Первый тест',
  Second = 'Второй тест',
  Third = 'Третий тест',
}

export const parallels = [2, 3, 4, 5, 6, 7, 8, 9];

export type CountsByParallels = Record<number, number>;
export type PercentsByParallels = Record<number, number>;

export interface StudentsRowProps {
  location: string;
  school?: string;
  studentCounts: CountsByParallels;
  noResults: boolean;
}

export interface PercentsRowProps {
  location: string;
  school: string;
  percentsByParallels: PercentsByParallels;
  averagePercent: number;
  testedStudentsCount: number;
  registeredStudentsCount: number;
  noResults: boolean;
}

export interface TotalPercentsRowProps {
  percentsByParallels: PercentsByParallels;
  averagePercent: number;
  registeredStudentsCount: number;
  testedStudentsCount: number;
}

export interface SubjectOption {
  id: Subject;
  label: string;
}

export interface TestRoundOption {
  id: TestRound;
  label: string;
}

export const subjectOptions = [
  { id: Subject.Math, label: 'Математика' },
  { id: Subject.Russian, label: 'Русский Язык' },
  // { id: Subject.English, label: 'Английский Язык' },
];

export const testRoundsOptions = [
  { id: TestRound.First, label: 'Тест первый' },
  { id: TestRound.Second, label: 'Тест второй' },
  { id: TestRound.Third, label: 'Тест третий' },
];

export interface StudentsTableProps {
  rows: StudentsRowProps[];
  total: CountsByParallels;
}

export interface PlateProps {
  isRegion: boolean;
  tests: Test[];
}
